import * as React from "react";
import type { SVGProps } from "react";
const SvgAlertCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 12V7.2m0 8.358v.042m9.6-3.6a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 1 1 19.2 0"
    />
  </svg>
);
export default SvgAlertCircle;
